module.exports = __webpack_public_path__ + "img/bioManta2.d923f360.png";